import React, { useEffect } from 'react'
import './Terms_Conditions.css'
import Green_Btn from '../common_components/common_btn/green_btn/Green_Btn'
import Light_Gray_Btn from '../common_components/common_btn/light_gray_btn/Light_Gray_Btn'
import { useNavigate } from 'react-router-dom'
import { useDispatch, useSelector } from 'react-redux'
import { getTerms_and_Conditions } from '../../features/terms_conditions.js/Slice'
import Breadcrumb_comp from '../common_components/breadcrumb-comp/Breadcrumb_comp'
import parse from "html-react-parser"

const Terms_Conditions = () => {

    const navigate = useNavigate()
    const breadcrumbs = [
        { label: "Home", link: "/", isActive: false },
        { label: "Terms and Conditions", link: "", isActive: true },
    ];

    const termsconditions = useSelector((state) => state.termsconditions.termsconditions)
    const dispatch = useDispatch()
    useEffect(() => {
        dispatch(getTerms_and_Conditions());

    }, [])

    return (

        <>
            <section className='Privacy_Policy Terms_Conditions'>
                <div className='bg_img_div'>
                    <div className='bg_div'>
                        {/* <img src='/assets/images/privacy/bg2.png' className='bg_img' /> */}
                    </div>
                    <div className='white_bg_div'>
                        <Breadcrumb_comp breadcrumbs={breadcrumbs} />
                        <div className='container'>
                            <p className='section_title'>Terms and Conditions</p>
                        </div>
                    </div>
                </div>
                <div className='container'>
                    <div className='main_content_div'>
                        {termsconditions?.data?.map((terms) => (<p className='dark_black_text'>{parse(terms.content)}</p>))}

                    </div>
                </div>
            </section >

            {/* <Stay_Connected /> */}
        </>


    )
}

export default Terms_Conditions
